(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-pnk"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-tnf-clubs-grid]').forEach(function(grid){
    var dotsContainer = grid.parentElement.querySelector('[data-tnf-clubs-dots]');
    if (!dotsContainer) return;

    var items = grid.querySelectorAll('[class*="tnf-clubs__item"]');
    if (items.length < 2) return;

    /* Calculate how many "pages" exist */
    function getPages(){
      var gridW = grid.offsetWidth;
      var scrollW = grid.scrollWidth;
      if (scrollW <= gridW) return 1;
      var itemW = items[0].offsetWidth + (parseInt(getComputedStyle(grid).gap) || 15);
      var visible = Math.floor(gridW / itemW);
      return Math.ceil(items.length / Math.max(visible, 1));
    }

    function buildDots(){
      dotsContainer.innerHTML = '';
      var pages = getPages();
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++){
        var dot = document.createElement('button');
        dot.className = 'tnf-clubs__dot';
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.dataset.page = i;
        dot.addEventListener('click', function(){
          var p = parseInt(this.dataset.page);
          var itemW = items[0].offsetWidth + (parseInt(getComputedStyle(grid).gap) || 15);
          var visible = Math.floor(grid.offsetWidth / itemW);
          grid.scrollTo({ left: p * visible * itemW, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
      updateActive();
    }

    function updateActive(){
      var dots = dotsContainer.querySelectorAll('.tnf-clubs__dot');
      if (!dots.length) return;
      var itemW = items[0].offsetWidth + (parseInt(getComputedStyle(grid).gap) || 15);
      var visible = Math.max(Math.floor(grid.offsetWidth / itemW), 1);
      var current = Math.round(grid.scrollLeft / (visible * itemW));
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === current); });
    }

    buildDots();
    grid.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', buildDots);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-customization"] && !Shopify.designMode) return;
  try {
    
(function(){
  var container = document.querySelector('.tnf-custom');
  if (!container) return;

  var btns = container.querySelectorAll('.tnf-custom__btn');
  var fields = container.querySelector('[data-tnf-fields]');
  var nameInput = container.querySelector('[data-tnf-name]');
  var numberInput = container.querySelector('[data-tnf-number]');
  var form = document.querySelector('form[action*="/cart/add"]');
  var mode = 'off';

  function setMode(newMode) {
    mode = newMode;
    btns.forEach(function(b) {
      b.classList.toggle('tnf-custom__btn--active', b.dataset.tnfMode === mode);
    });

    if (mode === 'on') {
      fields.style.display = 'block';
      syncForm();
    } else {
      fields.style.display = 'none';
      if (nameInput) { nameInput.value = ''; nameInput.classList.remove('tnf-custom__field--error'); }
      if (numberInput) { numberInput.value = ''; numberInput.classList.remove('tnf-custom__field--error'); }
      removeFromForm();
    }
  }

  btns.forEach(function(b) {
    b.addEventListener('click', function() {
      setMode(b.dataset.tnfMode);
    });
  });

  if (nameInput) {
    nameInput.addEventListener('input', function() {
      this.value = this.value.replace(/[0-9]/g, '').toUpperCase().replace(/\s{2,}/g, ' ');
      this.parentElement.classList.remove('tnf-custom__field--error');
      syncForm();
    });
  }

  if (numberInput) {
    numberInput.addEventListener('input', function() {
      this.value = this.value.replace(/[^0-9]/g, '');
      this.parentElement.classList.remove('tnf-custom__field--error');
      syncForm();
    });
  }

  function syncForm() {
    if (!form) return;
    removeFromForm();
    if (mode !== 'on') return;

    var name = nameInput ? nameInput.value.trim() : '';
    var num = numberInput ? numberInput.value.trim() : '';

    if (name) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[Name]'; h.value = name;
      h.setAttribute('data-tnf-custom', 'true');
      form.appendChild(h);
    }
    if (num) {
      var h2 = document.createElement('input');
      h2.type = 'hidden'; h2.name = 'properties[Number]'; h2.value = num;
      h2.setAttribute('data-tnf-custom', 'true');
      form.appendChild(h2);
    }
  }

  function removeFromForm() {
    if (!form) return;
    form.querySelectorAll('[data-tnf-custom]').forEach(function(el) { el.remove(); });
  }

  /* Validação no submit */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], button.product-form__submit, .btn-addtocart');
    if (!btn || mode !== 'on') return;

    var name = nameInput ? nameInput.value.trim() : '';
    var num = numberInput ? numberInput.value.trim() : '';

    if (!name && !num) {
      e.preventDefault();
      e.stopPropagation();
      if (nameInput) nameInput.parentElement.classList.add('tnf-custom__field--error');
      if (numberInput) numberInput.parentElement.classList.add('tnf-custom__field--error');
      return;
    }
    syncForm();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-patches"] && !Shopify.designMode) return;
  try {
    
(function(){
  var registry = document.getElementById('tnf-patch-registry');
  var tagsEl = document.getElementById('tnf-product-patch-tags');
  if (!registry || !tagsEl) return;

  var allPatches = JSON.parse(registry.textContent);
  var productTags = JSON.parse(tagsEl.textContent).map(function(t){ return t.toLowerCase(); });

  var patchCodes = [];
  productTags.forEach(function(t){
    if (/^p\d+$/.test(t)) patchCodes.push(t);
  });
  if (!patchCodes.length) return;

  var patches = allPatches.filter(function(p){ return patchCodes.indexOf(p.code) > -1; });
  if (!patches.length) return;

  var list = document.querySelector('[data-patches-list]');
  var summary = document.querySelector('[data-patches-summary]');
  if (!list) return;

  var form = document.querySelector('form[action*="/cart/add"]');
  var selected = {};

  patches.forEach(function(patch){
    var item = document.createElement('div');
    item.className = 'tnf-patches__item';
    item.setAttribute('role', 'checkbox');
    item.setAttribute('aria-checked', 'false');
    item.setAttribute('aria-label', patch.title);
    item.setAttribute('tabindex', '0');
    item.dataset.code = patch.code;
    item.dataset.location = patch.location;
    item.dataset.title = patch.title;

    item.innerHTML =
      '<div class="tnf-patches__check"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg></div>' +
      '<img class="tnf-patches__img" src="' + patch.image + '" alt="' + patch.title + '" loading="lazy" width="36" height="36">' +
      '<div class="tnf-patches__info"><span class="tnf-patches__name">' + patch.title + '</span><span class="tnf-patches__loc">' + patch.location + '</span></div>';

    item.addEventListener('click', function(){ toggle(item, patch); });
    item.addEventListener('keydown', function(e){ if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(item, patch); } });

    list.appendChild(item);
  });

  function toggle(item, patch) {
    var loc = patch.location;
    var wasActive = item.classList.contains('tnf-patches__item--active');

    if (wasActive) {
      item.classList.remove('tnf-patches__item--active');
      item.setAttribute('aria-checked', 'false');
      delete selected[loc];
    } else {
      list.querySelectorAll('.tnf-patches__item[data-location="' + loc + '"]').forEach(function(el){
        el.classList.remove('tnf-patches__item--active');
        el.setAttribute('aria-checked', 'false');
      });
      item.classList.add('tnf-patches__item--active');
      item.setAttribute('aria-checked', 'true');
      selected[loc] = patch.title;
    }
    updateSummary();
    injectForm();
  }

  function updateSummary() {
    var names = [];
    for (var loc in selected) names.push(selected[loc]);
    summary.textContent = names.length ? names.join(', ') : '';
  }

  function injectForm() {
    if (!form) return;
    form.querySelectorAll('[data-tnf-patch]').forEach(function(el){ el.remove(); });
    for (var loc in selected) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Patch (' + loc + ')]';
      input.value = selected[loc];
      input.setAttribute('data-tnf-patch', 'true');
      form.appendChild(input);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-league"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-sbl-open]').forEach(function(trigger){
    trigger.addEventListener('click', function(){
      var sectionId = this.dataset.sblSection;
      var index = parseInt(this.dataset.sblOpen);
      var overlay = document.querySelector('[data-sbl-overlay="' + sectionId + '"]');
      if (!overlay) return;
      overlay.classList.add('is-open');
      activateTab(overlay, index);
    });
  });

  document.querySelectorAll('[data-sbl-close]').forEach(function(btn){
    btn.addEventListener('click', function(){
      this.closest('[data-sbl-overlay]').classList.remove('is-open');
    });
  });

  document.querySelectorAll('[data-sbl-overlay]').forEach(function(overlay){
    overlay.addEventListener('click', function(e){
      if (e.target === overlay) overlay.classList.remove('is-open');
    });

    overlay.querySelectorAll('[data-sbl-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        activateTab(overlay, parseInt(this.dataset.sblTab));
      });
    });
  });

  function activateTab(overlay, index){
    overlay.querySelectorAll('.sbl-tab').forEach(function(t, i){
      t.classList.toggle('is-active', i === index);
    });
    overlay.querySelectorAll('.sbl-panel').forEach(function(p, i){
      p.classList.toggle('is-active', i === index);
    });
    var activeTab = overlay.querySelectorAll('.sbl-tab')[index];
    if (activeTab) activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-celebration"] && !Shopify.designMode) return;
  try {
    
(function(){
  var canvas = document.querySelector('.tnf-celeb__canvas');
  if (!canvas) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ctx = canvas.getContext('2d');
  var particles = [];
  var rockets = [];
  var raf;

  function resize() {
    var rect = canvas.parentElement.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
  }
  resize();
  window.addEventListener('resize', resize);

  var colors = ['#ff3c3c','#ffd700','#ff6b35','#ffec44','#ff1744','#ffab00','#ffffff'];

  function Particle(x, y, color) {
    this.x = x; this.y = y; this.color = color;
    var angle = Math.random() * Math.PI * 2;
    var speed = Math.random() * 4 + 1;
    this.vx = Math.cos(angle) * speed;
    this.vy = Math.sin(angle) * speed;
    this.alpha = 1;
    this.decay = Math.random() * 0.015 + 0.005;
    this.size = Math.random() * 2.5 + 0.5;
  }
  Particle.prototype.update = function() {
    this.x += this.vx; this.y += this.vy;
    this.vy += 0.03; this.vx *= 0.99;
    this.alpha -= this.decay;
  };
  Particle.prototype.draw = function() {
    ctx.save();
    ctx.globalAlpha = Math.max(0, this.alpha);
    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  };

  function Rocket(x) {
    this.x = x; this.y = canvas.height;
    this.vy = -(Math.random() * 4 + 5);
    this.targetY = Math.random() * canvas.height * 0.4 + canvas.height * 0.1;
    this.exploded = false;
    this.color = colors[Math.floor(Math.random() * colors.length)];
    this.trail = [];
  }
  Rocket.prototype.update = function() {
    this.trail.push({ x: this.x, y: this.y, alpha: 0.5 });
    if (this.trail.length > 8) this.trail.shift();
    this.y += this.vy; this.vy *= 0.98;
    if (this.y <= this.targetY) {
      this.exploded = true;
      var count = 40 + Math.floor(Math.random() * 30);
      for (var i = 0; i < count; i++) particles.push(new Particle(this.x, this.y, this.color));
    }
  };
  Rocket.prototype.draw = function() {
    for (var i = 0; i < this.trail.length; i++) {
      var t = this.trail[i];
      ctx.save();
      ctx.globalAlpha = t.alpha * (i / this.trail.length);
      ctx.fillStyle = '#ffd700';
      ctx.beginPath();
      ctx.arc(t.x, t.y, 1.5, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
    ctx.save();
    ctx.fillStyle = '#ffd700';
    ctx.beginPath();
    ctx.arc(this.x, this.y, 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  };

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (Math.random() < 0.03) rockets.push(new Rocket(Math.random() * canvas.width));
    for (var i = rockets.length - 1; i >= 0; i--) {
      rockets[i].update();
      if (!rockets[i].exploded) rockets[i].draw();
      else rockets.splice(i, 1);
    }
    for (var j = particles.length - 1; j >= 0; j--) {
      particles[j].update();
      if (particles[j].alpha > 0) particles[j].draw();
      else particles.splice(j, 1);
    }
    raf = requestAnimationFrame(loop);
  }

  var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) { loop(); }
    else { cancelAnimationFrame(raf); ctx.clearRect(0, 0, canvas.width, canvas.height); }
  }, { threshold: 0.1 });
  observer.observe(canvas.parentElement);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-countdown-hud"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-tnf-countdown]').forEach(function(el){
    var target = new Date(el.dataset.target).getTime();
    var expiredText = el.dataset.expired || 'LIVE NOW';
    var dEl = el.querySelector('[data-d]');
    var hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');
    if (!dEl) return;

    function pad(n){ return n < 10 ? '0' + n : '' + n; }

    function tick(){
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        el.innerHTML = '<span class="tnf-hud__expired">' + expiredText + '</span>';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      dEl.textContent = pad(d);
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-product-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ── YouTube lazy embed ── */
  document.querySelectorAll('[data-tnf-pv-yt]').forEach(function(el) {
    el.addEventListener('click', function() {
      var id = this.dataset.tnfPvYt;
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      this.appendChild(iframe);
      this.classList.add('tnf-pv__player--loaded');
    });
  });

  /* ── Vimeo lazy embed ── */
  document.querySelectorAll('[data-tnf-pv-vimeo]').forEach(function(el) {
    el.addEventListener('click', function() {
      var id = this.dataset.tnfPvVimeo;
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      iframe.allow = 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      this.appendChild(iframe);
      this.classList.add('tnf-pv__player--loaded');
    });
  });

  /* ── Native video play/pause toggle ── */
  document.querySelectorAll('.tnf-pv__play-btn--toggle').forEach(function(btn) {
    var player = btn.closest('.tnf-pv__player--native');
    var video = player ? player.querySelector('video') : null;
    if (!video) return;

    var playIcon = btn.querySelector('.tnf-pv__icon-play');
    var pauseIcon = btn.querySelector('.tnf-pv__icon-pause');

    function updateState() {
      if (video.paused) {
        player.classList.add('is-paused');
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      } else {
        player.classList.remove('is-paused');
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';
      }
    }

    btn.addEventListener('click', function() {
      if (video.paused) video.play();
      else video.pause();
    });

    video.addEventListener('play', updateState);
    video.addEventListener('pause', updateState);
    updateState();
  });

  /* ── Autoplay on viewport (IntersectionObserver) ── */
  document.querySelectorAll('.tnf-pv__player--native video[autoplay]').forEach(function(video) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) video.play().catch(function(){});
        else video.pause();
      });
    }, { threshold: 0.3 });
    observer.observe(video);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-promo-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar = document.querySelector('[data-tnf-promo]');
  if (!bar) return;

  var tiers = [
    { qty: parseInt(bar.dataset.tier1Qty), total: parseInt(bar.dataset.tier1Total) },
    { qty: parseInt(bar.dataset.tier2Qty), total: parseInt(bar.dataset.tier2Total) },
    { qty: parseInt(bar.dataset.tier3Qty), total: parseInt(bar.dataset.tier3Total) }
  ];

  var textEl = bar.querySelector('[data-tnf-promo-text]');

 /* Detect language */
  var isES = window.location.pathname.indexOf('/es') === 0 || document.documentElement.lang === 'es';

  function update(cartItems) {
    var qty = 0;
    cartItems.forEach(function(item) { qty += item.quantity; });

    var msg = '';

    if (isES) {
      if (qty < tiers[0].total) {
        var r = tiers[0].total - qty;
        if (qty === 0) {
          msg = 'Añade ' + tiers[0].total + ' camisetas y paga solo ' + tiers[0].qty + '!';
        } else {
          msg = qty + ' camiseta' + (qty > 1 ? 's' : '') + ' en el carrito — Añade ' + r + ' más y paga solo ' + tiers[0].qty + '!';
        }
      } else if (qty < tiers[1].total) {
        var free = tiers[0].total - tiers[0].qty;
        var r = tiers[1].total - qty;
        msg = '🎉 ' + free + ' camiseta' + (free > 1 ? 's' : '') + ' GRATIS desbloqueada' + (free > 1 ? 's' : '') + '! Añade ' + r + ' más para ' + (tiers[1].total - tiers[1].qty) + ' GRATIS!';
      } else if (qty < tiers[2].total) {
        var free = tiers[1].total - tiers[1].qty;
        var r = tiers[2].total - qty;
        msg = '🎉 ' + free + ' camisetas GRATIS desbloqueadas! Añade ' + r + ' más para ' + (tiers[2].total - tiers[2].qty) + ' GRATIS!';
      } else {
        var free = tiers[2].total - tiers[2].qty;
        msg = '🔥 OFERTA MÁXIMA — ' + free + ' camisetas GRATIS desbloqueadas!';
      }
    } else {
      if (qty < tiers[0].total) {
        var r = tiers[0].total - qty;
        if (qty === 0) {
          msg = 'Add ' + tiers[0].total + ' shirts and pay only for ' + tiers[0].qty + '!';
        } else {
          msg = qty + ' shirt' + (qty > 1 ? 's' : '') + ' in cart — Add ' + r + ' more and pay only for ' + tiers[0].qty + '!';
        }
      } else if (qty < tiers[1].total) {
        var free = tiers[0].total - tiers[0].qty;
        var r = tiers[1].total - qty;
        msg = '🎉 ' + free + ' FREE shirt' + (free > 1 ? 's' : '') + ' unlocked! Add ' + r + ' more for ' + (tiers[1].total - tiers[1].qty) + ' FREE!';
      } else if (qty < tiers[2].total) {
        var free = tiers[1].total - tiers[1].qty;
        var r = tiers[2].total - qty;
        msg = '🎉 ' + free + ' FREE shirts unlocked! Add ' + r + ' more for ' + (tiers[2].total - tiers[2].qty) + ' FREE!';
      } else {
        var free = tiers[2].total - tiers[2].qty;
        msg = '🔥 MAXIMUM DEAL — ' + free + ' FREE shirts unlocked!';
      }
    }

    textEl.textContent = msg;
  }
  
  function fetchAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { update(cart.items); })
      .catch(function() {});
  }

  fetchAndUpdate();

  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1)) {
      result.then(function() {
        setTimeout(fetchAndUpdate, 300);
      });
    }
    return result;
  };

  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1)) {
      this.addEventListener('load', function() { setTimeout(fetchAndUpdate, 300); });
    }
    return origXHROpen.apply(this, arguments);
  };

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', fetchAndUpdate);
  }

 /* ── Follow header position in real-time ── */
  var headerSection = document.querySelector('.section-header');
  var promoSection = document.getElementById('shopify-section-tnf-promo-bar');
  if (headerSection && promoSection) {
    function syncPosition() {
      var rect = headerSection.getBoundingClientRect();
      promoSection.style.top = Math.max(0, rect.bottom) + 'px';
      requestAnimationFrame(syncPosition);
    }
    requestAnimationFrame(syncPosition);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-reels"] && !Shopify.designMode) return;
  try {
    
(function(){
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-tnf-carousel]').forEach(function(carousel){
    var track = carousel.querySelector('[data-tnf-track]');
    var prev = carousel.querySelector('[data-tnf-prev]');
    var next = carousel.querySelector('[data-tnf-next]');
    if (!track) return;

    var videoRadius = getComputedStyle(track.closest('.tnf-reels')).getPropertyValue('--tr-video-radius');
    if (videoRadius && parseInt(videoRadius) > 0) {
      track.querySelectorAll('.tnf-reels__video-wrap').forEach(function(w){ w.style.margin = '4px 4px 0'; });
    }

    function scrollAmount(){
      var s = track.querySelector('.tnf-reels__slide');
      return s ? s.offsetWidth + (parseInt(getComputedStyle(track).gap) || 16) : 300;
    }
    function updateArrows(){
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -scrollAmount(), behavior: prefersReduced ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function(){ track.scrollBy({ left: scrollAmount(), behavior: prefersReduced ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    /* ── Autoplay: todos os vídeos tocam quando a seção entra no viewport ── */
    var allWraps = track.querySelectorAll('.tnf-reels__video-wrap');

    function loadVideo(vid){
      if (vid.dataset.src && !vid.src) {
        vid.src = vid.dataset.src;
        vid.removeAttribute('data-src');
      }
    }

    function playAll(){
      allWraps.forEach(function(wrap){
        var vid = wrap.querySelector('.tnf-reels__video');
        if (!vid) return;
        loadVideo(vid);
        vid.play().then(function(){ wrap.classList.add('is-playing'); }).catch(function(){});
      });
    }

    function pauseAll(){
      allWraps.forEach(function(wrap){
        var vid = wrap.querySelector('.tnf-reels__video');
        if (!vid) return;
        vid.pause();
        wrap.classList.remove('is-playing');
      });
    }

    if ('IntersectionObserver' in window) {
      var sectionObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            playAll();
          } else {
            pauseAll();
          }
        });
      }, { threshold: 0.15 });
      sectionObs.observe(carousel);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
